import { useMemo } from 'react';
import AppointmentForm from './components/AppointmentForm';
import Footer from './components/Footer';
import ZoomOverrideBanner from './components/ZoomOverrideBanner';

function parseQueryString(): Record<string, string> {
  const out: Record<string, string> = {};
  new URLSearchParams(window.location.search).forEach((v, k) => {
    out[k] = v;
  });
  return out;
}

function useSearchParamsRecord(): Record<string, string> {
  return useMemo(() => parseQueryString(), []);
}

function TopBar() {
  return (
    <div className="bg-nhs-blue text-white">
      <div className="mx-auto max-w-220 flex items-center justify-between px-4 lg:px-6 py-2">
        <a
          href="tel:+441737768511"
          className="flex items-center gap-2 text-white hover:underline"
          aria-label="Call us on 01737 768 511"
        >
          <img
            src="/images/phone-icon.png"
            alt=""
            aria-hidden="true"
            width={20}
            height={20}
            className="brightness-0 invert w-4.5 lg:w-5 h-auto"
          />
          <span className="text-base lg:text-lg font-bold pl-1">01737 768 511</span>
        </a>
      </div>
    </div>
  );
}

function Header() {
  return (
    <div className="bg-white border-b border-card-border">
      <div className="mx-auto max-w-220 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 px-4 lg:px-6 py-4">
        <a href="/" aria-label="Surrey and Sussex Healthcare NHS Trust home">
          <img
            src="/images/SASH-logo-colour-left-aligned-RGB.png"
            alt="Surrey and Sussex Healthcare NHS Trust"
            width={280}
            height={88}
            className="w-60 lg:w-70 h-auto"
          />
        </a>
        <div className="pl-2.5 sm:pl-0 text-left sm:text-right text-text-muted text-[16px] leading-tight">
          <div className="font-bold text-text text-xl">Virtual Hospital</div>
          Video consultations
        </div>
      </div>
    </div>
  );
}

function MainContent({ searchParams }: { searchParams: Record<string, string> }) {
  return (
    <main id="main-content" className="flex-1 px-4 py-8 lg:py-10">
      <div className="mx-auto max-w-180">
        <AppointmentForm searchParams={searchParams} />
      </div>
    </main>
  );
}

export default function App() {
  const searchParams = useSearchParamsRecord();

  return (
    <div className="min-h-screen flex flex-col bg-[#f7f9fa]">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <ZoomOverrideBanner />
      <TopBar />
      <Header />
      <MainContent searchParams={searchParams} />
      <Footer />
    </div>
  );
}
